<template>
  <div v-show="isActive" class="widgetContainer" id="geoprocessingID">
    <div class="map-tool-window-header" id="geoprocessingIDheader">
      <p class="map-tool-window-header-title">Ejecutar Geoproceso</p>
      <div class="map-tool-window-header-actions">
        <button class="control-btn" v-on:click="isHidden = !isHidden">
            <svg  v-if="isHidden"
            viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            <svg v-else
              viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/></svg>
          <!-- <font-awesome-icon v-if="!isHidden" icon="minus"></font-awesome-icon>
          <font-awesome-icon v-else icon="plus"></font-awesome-icon> -->
        </button>
        <button class="control-btn" v-on:click="exitGeoprocessing()">
          <!-- <font-awesome-icon icon="times"></font-awesome-icon> -->
          <svg viewBox="0 0 24 24"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>
        </button>
      </div>
    </div>
    <label for="geoprocessSelect">Geoproceso:</label>
    <select id="geoprocessSelect" v-model="selectedGeoprocessId">
      <option disabled value="">Seleccionar...</option>
      <option v-for="option in geoprocessingsOptions" :key="option.id" :value="option.id">
        {{ option.name }}
      </option>
    </select>

    <component :is="activeFormComponent" v-if="activeFormComponent" @submit="handleSubmit"
      @changeDrawType="onChangeDrawType" @generateRings="onGenerateRings"
      @updateGeoprocessingBody="onUpdateGeoprocessingBody" />

    <div class="action-buttons">
      <button class="btn-clean" @click="cleanMode()">
        Limpiar
      </button>
      <button class="btn-execute" @click="executeGeoprocessingVue()" :disabled="loading">
        <font-awesome-icon v-if="loading" icon="spinner" spin />
        {{ loading ? ' Procesando...' : 'Ejecutar' }}
      </button>
    </div>
  </div>
</template>

<script>
import { draggableDiv } from "@/components/mixin/draggableDiv.js";
import { vuex } from "@/components/mixin/vuex.js";
import { geoprocessingsInteraction } from "./geoprocessingsInteraction.js";
import { mapService } from "@/services/map/mapService";
import InfluenciaRadialForm from "./forms/InfluenciaRadialForm.vue";
import InfluenciaLinealForm from "./forms/InfluenciaLinealForm.vue";
import InfluenciaPoligonalForm from "./forms/InfluenciaPoligonalForm.vue";
import GeoJSON from 'ol/format/GeoJSON';
import Circle from 'ol/geom/Circle';
import { fromCircle } from 'ol/geom/Polygon';
import { LayerService } from '@/services/layers/layerService';
import { geoprocessingSelectionHandler } from '@/components/mapTools/geoprocessings/utils/GeoprocessingSelectionHandler';

export default {
  name: "HelloWorld",
  props: ["isFixed"],
  mixins: [draggableDiv, vuex, geoprocessingsInteraction],
  data() {
    return {
      errorMessage: "",
      selectedGeoprocessId: "",
      chartData: null,
      geoprocessingsOptions: [
        { id: "InfluenciaRadial", name: "Influencia Radial" },
        { id: "InfluenciaLineal", name: "Influencia Lineal" },
        { id: "InfluenciaPoligonal", name: "Influencia Poligonal" },
      ],

      // ✅ solo para leer lo que emite el hijo
      formDataFromChild: null,

      geoprocessingBody: {
        layers: [],
        geometry: {
          coordinates: [],
          type: "Polygon",
        },
        radius: 1,
      },
      geoRequestData: null,

      geoprocessingUrl: "-1",
      drawSelected: { name: "Polígono", code: "Polygon" },
      draws: [
        { name: "Polígono", code: "Polygon" },
        { name: "Círculo", code: "Circle" },
      ],

      isHidden: false,
      loading: false,
    };
  },
  computed: {
    isActive() {
      return this.isFixed
        ? this.isMobile
        : this.mapToolValues("geoprocessing").active && !this.isMobile;
    },
    selectedGeoprocess() {
      return this.geoprocessingsOptions.find((g) => g.id === this.selectedGeoprocessId);
    },
    activeFormComponent() {
      console.log("Form seleccionado:", this.selectedGeoprocessId);
      switch (this.selectedGeoprocessId) {
        case "InfluenciaRadial":
          return InfluenciaRadialForm;
        case "InfluenciaLineal":
          return InfluenciaLinealForm;
        case "InfluenciaPoligonal":
          return InfluenciaPoligonalForm;
        default:
          return null;
      }
    },
  },
  methods: {
    // ✅ guardamos lo que manda el hijo (sin cambiar tu flujo)
    onUpdateGeoprocessingBody(newBody) {
      console.log("📬 GeoprocessingBody recibido:", newBody);
      this.geoprocessingBody = newBody; // <- lo tuyo original
      this.formDataFromChild = newBody; // <- solo guardamos para usar en payload
    },

    cleanMode() {
      this.executeMapToolAction("geoprocessing", "clean", {});
      this.cleanGeoDraw();
      geoprocessingSelectionHandler.clearHighlight();
      this.chartData = null;
    },
    exitGeoprocessing() {
      this.cleanResults();
      this.selectMapTool("geoprocessing", false);
      this.errorMessage = "";
    },

    async executeGeoprocessingVue() {
      this.loading = true;
      try {
        console.log("Ejecutando geoproceso...");
        // 🔄 Limpiar resultados previos para dar feedback visual de "procesando"
        this.cleanResults();

        let layersToProcess = [];
        const mode = (this.formDataFromChild && this.formDataFromChild.capas) || "todas";
        const allLayersCategories = this.$store.getters.getLayers || [];

        // Helper to flatten categories into a single array of layers
        const flattenLayers = (categories) => {
          let all = [];
          categories.forEach(cat => {
            if (cat.layers) all = all.concat(cat.layers);
          });
          return all;
        };

        if (mode === "todas") {
          // Use ONLY layers marked as vulnerable from the backend
          layersToProcess = await LayerService.getVulnerableLayers();
        } else if (mode === "cargadas") {
          // Use ONLY layers currently active/checked on the map
          layersToProcess = this.activeLayers;
        } else if (mode === "seleccionar") {
          // Use specifically selected IDs from the modal
          const ids = (this.formDataFromChild && this.formDataFromChild.capasSeleccionadas) || [];
          const flatAll = flattenLayers(allLayersCategories);

          layersToProcess = ids.map(id => {
            const found = flatAll.find(l => l.id == id);
            if (found) return found;
            console.warn(`⚠️ Capa con ID ${id} no encontrada.`);
            return null;
          }).filter(l => l !== null);
        }

        console.log(`Modo de capas: ${mode}, Capas a procesar: ${layersToProcess.length}`);

        if (layersToProcess.length === 0) {
          alert("No hay capas seleccionadas/activas para procesar.");
          return;
        }

        console.log("🧱 geoRequestData actual:", this.geoRequestData);
        console.log("📝 FormData From Child:", this.formDataFromChild);

        let finalInputGeometries = [];
        const usingLayerSelection = this.formDataFromChild && this.formDataFromChild.otrasCapas;

        // 1. Check for Selection from Child (Highest Priority)
        if (this.formDataFromChild && this.formDataFromChild.seleccionInfo && this.formDataFromChild.seleccionInfo.features) {
          console.log("🛠️ Using features from Selection Handler");
          const format = new GeoJSON();
          const features = this.formDataFromChild.seleccionInfo.features;

          // Filter features based on Process Type
          if (this.selectedGeoprocessId === 'InfluenciaRadial') {
            // For Radial, we must buffer the Points (Centers) by the requested proper radii
            // because the backend expects Polygons with a radius property, identical to drawn circles.
            const pointFeatures = features.filter(f => f.getGeometry().getType() === 'Point');

            // Get requested radii from form data
            const radiuses = (this.formDataFromChild.distancias) || [1]; // default 1km if missing

            pointFeatures.forEach(f => {
              const center = f.getGeometry().getCoordinates();
              radiuses.forEach(distM => {
                const radiusMeters = distM;
                const circleGeom = new Circle(center, radiusMeters);
                const polygonGeom = fromCircle(circleGeom);

                finalInputGeometries.push({
                  type: "Polygon",
                  coordinates: polygonGeom.getCoordinates(),
                  radius: radiusMeters
                });
              });
            });
          } else {
            // For other types, pass geometry as is
            finalInputGeometries = features.map(f => format.writeGeometryObject(f.getGeometry()));
          }
        }
        else if (usingLayerSelection) {
          // User checked "Other Layers" but no selection info is available
          alert("Ha seleccionado 'Usar elementos de otras capas' pero no ha seleccionado ningún elemento. Por favor use el botón 'Seleccione elementos' y dibuje un área sobre los puntos deseados.");
          return;
        }
        // 2. Fallback to Standard Drawing (Only if NOT using layer selection)
        else if (this.geoRequestData && this.geoRequestData.input_geometries) {
          finalInputGeometries = this.geoRequestData.input_geometries;
        }

        if (!finalInputGeometries || finalInputGeometries.length === 0) {
          alert("No hay geometría generada aún. (Dibuje un área o seleccione elementos)");
          return;
        }

        const layers = layersToProcess.map((l) => (
          console.log("🚀 Capa y su campos", l.campos),
          {
            id: l.id,
            name: l.name,
            source: l.source,
            type: l.type,
            provider: l.provider,
            codigo: l.codigo, // Required for ArcGIS sublayer identification
            campos: l.campos,
          }));
        console.log("🚀 Capas", layers);

        // ✅ Standardized Payload Construction
        const method = (this.formDataFromChild && this.formDataFromChild.metodo) || "polygon";
        console.log("🚀 Obteniendo capas de población...", this.formDataFromChild.metodo);
        const capasPoblacion = await LayerService.getPoblationLayers(this.formDataFromChild.metodo);

        const payload = {
          layers: layers,
          input_geometries: finalInputGeometries,
          process_type: this.selectedGeoprocessId,
          calculation_method: method,
          capas_poblacion: capasPoblacion,
          dissolve: (this.formDataFromChild && this.formDataFromChild.dissolve) || false,
          ...(this.formDataFromChild && this.formDataFromChild.distancias ? { radiuses: this.formDataFromChild.distancias } : {}),
        };

        console.log("🚀 Enviando payload al backend:", payload);

        const url = process.env.VUE_APP_API_GEOPROCESS + "execute"; // TODO : cambiar al URL real
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });
        const responseJson = await response.json();
        console.log("✅ Respuesta recibida del backend:", responseJson);
        const graphResponse = responseJson["result"]["results_graphs"];
        const rawResults = responseJson["result"]["results"] || [];

        // Extract unique layers from results
        const uniqueLayers = [];
        const seenIds = new Set();

        rawResults.forEach(item => {
          if (item.layer && !seenIds.has(item.layer.id)) {
            uniqueLayers.push(item.layer);
            seenIds.add(item.layer.id);
          }
        });

        // Attach layers to graphResponse to access them in the Chart component
        graphResponse.availableLayers = uniqueLayers;
        graphResponse.rawResults = rawResults;
        graphResponse.results_table = responseJson["result"]["results_table"] || {};

        // Pasamos la geometría de filtro (priorizamos la que viene del backend, que puede estar disuelta)
        const responseGeometries = responseJson["result"]["input_geometries"] || [];
        if (responseGeometries.length > 0) {
          graphResponse.filterGeometry = responseGeometries[0];
          
          // Si se aplicó dissolve, actualizamos las marcas visuales en el mapa para mostrar el área unificada
          if (this.formDataFromChild && this.formDataFromChild.dissolve) {
             const format = new GeoJSON();
             const dissolvedFeatures = responseGeometries.map(g => format.readFeature({
                type: 'Feature',
                geometry: g,
                properties: {}
             }));
             // Actualizamos el SelectionHandler para que muestre solo la geometría disuelta
             geoprocessingSelectionHandler.highlightFeatures(dissolvedFeatures, false);
          }
        } else if (finalInputGeometries && finalInputGeometries.length > 0) {
          graphResponse.filterGeometry = finalInputGeometries[0];
        }

        // Add Population Graphs if available
        if (responseJson["result"]["population_graphs"]) {
          graphResponse.population = responseJson["result"]["population_graphs"];
        }

        // Pass PDF Data
        if (responseJson["result"]["pdf_report"]) {
          graphResponse.pdfReport = responseJson["result"]["pdf_report"];
        }

        console.log("📈 Respuesta del geoproceso:", graphResponse);
        this.chartData = graphResponse;

        // Emitir resultado para que otros componentes (ej. GeoprocessingChart) lo tomen via Vuex o evento global
        this.executeMapToolAction("geoprocessing", "showResults", {
          chartData: graphResponse,
          timestamp: Date.now()
        });
        this.$emit("geoprocessing-result", graphResponse);

      } catch (error) {
        console.error("Error al ejecutar el geoproceso:", error);
        alert("Ocurrió un error al ejecutar el geoproceso.");
      } finally {
        this.loading = false;
      }
    },

    showResults() {
      this.executeMapToolAction("geoprocessing", "showResults", {});
    },
    cleanResults() {
      this.errorMessage = "";
      this.executeMapToolAction("geoprocessing", "cleanResults", {});
    },
    showError(error) {
      this.errorMessage = error;
    },
    drawChange() {
      this.executeMapToolAction("geoprocessing", "changeDrawType", {
        drawType: this.drawSelected,
      });
    },

    // ✅ opcional: cuando el hijo hace submit explícito
    handleSubmit(formData) {
      console.log("handleSubmit formData:", formData);
      this.formDataFromChild = formData; // solo almacenamos
    },

    onChangeDrawType(drawType) {
      this.executeMapToolAction("geoprocessing", "clean", {});
      this.addGeoInteraction(drawType);
      this.drawSelected = drawType;
      this.executeMapToolAction("geoprocessing", "changeDrawType", { drawType });
    },
    onGenerateRings({ distances }) {
      console.log("📏 Dibujar radios en mapa:", distances);
      if (!Array.isArray(distances) || distances.length === 0) {
        alert("Debe ingresar al menos un radio válido.");
        return;
      }
      for (let i = 1; i < distances.length; i++) {
        if (distances[i] <= distances[i - 1]) {
          return;
        }
      }
      console.log("✅ Radios válidos, dibujando en mapa...");
      this.drawRings(distances);
    },
  },
  mounted() {
    this.makeDraggable("geoprocessingID");
    this.map = mapService.get();
  },
  beforeDestroy() {
    this.cleanResults();
    this.removeGeoInteraction();
    this.selectMapTool("geoprocessing", false);
  },
  watch: {
    mapToolExecuted: function (newValue, oldValue) {
      switch (newValue) {
        case "geoprocessing":
          const action = this.mapToolValues("geoprocessing").action;
          const data = this.mapToolValues("geoprocessing").data;

          if (action === "sendError") {
            this.showError(data.errorMessage);
          }

          if (action === "ready") {
            console.log(
              "📨 Recibido geoRequestData desde requests:",
              data.geoRequestData
            );
            this.geoRequestData = JSON.parse(JSON.stringify(data.geoRequestData)); // ✅ copia real, no referencia
            console.log("🧱 geoRequestData guardado en componente:", this.geoRequestData);
          }
          break;

        default:
          break;
      }
    },
    // ✅ Limpiar mapa al cambiar de geoproceso
    selectedGeoprocessId: function (val) {
      console.log("🔄 Cambio de geoproceso, limpiando mapa...");
      this.cleanMode();
      this.removeGeoInteraction();
    },
    // ✅ Limpiar interacciones de dibujo si el usuario cambia a modo "Usar capa existente"
    'formDataFromChild.otrasCapas': function (val) {
      if (val) {
        console.log("🔄 Cambio a modo capa, removiendo interacciones de dibujo...");
        this.removeGeoInteraction();
      }
    },
    'formDataFromChild.dissolve': function (val) {
      console.log("🔄 Cambio en Dissolve:", val);
      geoprocessingSelectionHandler.updateOptions({ dissolve: val });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.measure-container {
  position: absolute;
  left: 0.5em;
  top: 4em;
  padding: 0.5em;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  width: 300px;
}

.action-buttons {
  display: flex;
  gap: 10px;
  margin-top: 8px;
}

.btn-clean {
  flex: 1;
  border-radius: 8px;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  color: #495057;
  font-weight: 600;
  padding: 6px 0;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    background: #e9ecef;
    border-color: #ced4da;
  }
}

.btn-execute {
  flex: 1;
  border-radius: 8px;
  background: linear-gradient(135deg, #337ab7 0%, #286090 100%);
  border: none;
  color: white;
  font-weight: 600;
  padding: 6px 0;
  transition: all 0.2s;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(51, 122, 183, 0.2);

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 12px rgba(51, 122, 183, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
}
</style>
